import type { QueryClient, UseQueryOptions } from '@tanstack/react-query';

export * from '@tanstack/react-query';

export {
  createQueryClient,
  defaultQueryClientOptions,
  type CreateQueryClientOptions,
  type MutationErrorContext,
  type MutationMeta,
  type QueryErrorContext,
  type QueryMeta,
  type ShouldLogQueryError,
} from './createQueryClient';

export const tsClientOptions = {
  queryOptions: {
    retry: false,
  },
  mutationOptions: {},
} as const;

/**
 * Prefetches `query` and returns the cached value typed as `T`. The narrower return type
 * is the main reason to prefer this over calling `queryClient.prefetchQuery` directly,
 * which resolves to `void`.
 */
export async function prefetchQuery<T>(queryClient: QueryClient, query: UseQueryOptions<T>) {
  await queryClient.prefetchQuery(query);
  return queryClient.getQueryData<T>(query.queryKey) as T;
}

/**
 * @deprecated Import `DefaultQueryProvider` (or the new `QueryProvider`) from
 * `@zg-rentals/react-query5/client`.
 */
export { DefaultQueryProvider } from './client';

export { ReactQueryDevtools } from '@tanstack/react-query-devtools';
